import React from 'react';
import KnotchGraph from '@bit/knotchinc.web-react-components.graphs.knotch-graph';
import { HorizontalFillBar } from 'components/Graphs/FillBars';
import { percentageOf } from 'helpers/Utils.js';
import { TileContentContainer, ItemBreakdownContainer } from './styled.js';

const validate = ({ data, unit = 'value' }) => {
  const validated = data.every(item => !!item[unit] || item.fillPct === null || item.fillPct < 0 || item.fillPct > 100);

  return validated;
};

const ContentBreakdownTile = (props) => {
  const { num_videos = 0, num_articles = 0, num_contents = 0 } = props.entity;
  /*
    We'll calculate percentages of each to know how much
    of the bar to fill in and with what color by looking
    at how much of the total (num_contents) each slice is
   */
  const pctArticles = percentageOf(num_articles, num_contents, true);
  const pctVideos = percentageOf(num_videos, num_contents, true);
  const data = [
    {
      label: 'Articles',
      fillPct: pctArticles,
      value: pctArticles,
    },
    {
      label: 'Videos',
      fillPct: pctVideos,
      value: pctVideos,
    },
  ];

  return (
    <TileContentContainer>
      <KnotchGraph validate={validate} data={data} unit="value">
        {data.map((item, idx) => (
          <ItemBreakdownContainer key={`${item.label}-${idx}`}>
            <HorizontalFillBar stacked {...item} />
          </ItemBreakdownContainer>
        ))}
      </KnotchGraph>
    </TileContentContainer>
  );
};

export default ContentBreakdownTile;
